import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import Centro from "../classes/CentroDistribuicao";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "DadosBasico/CentroVirtual/All" },
  { method: "GET", rota: "DadosBasico/CentroVirtual/{id}" },
  { method: "POST", rota: "DadosBasico/CentroVirtual/Adicionar" },
  { method: "PUT", rota: "DadosBasico/CentroVirtual/Atualizar" },
  { method: "DELETE", rota: "DadosBasico/CentroVirtual/Atualizar" },
  { method: "GET", rota: "DadosBasico/CentroVirtual/Count"}
];

const cacheKey: string = "centroCache";
const cacheKeySelC: string = "centroSelecionado";

const apiServico: String = "PORTAL";

class CentroDataset extends httpClient {
  constructor() {
    super(String(apiServico));
  }
  Adicionar(value: Centro) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[3].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  Atualizar(value: Centro) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[3].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async ListarQuantidadeDeCentroVirtual(): Promise<number> {
    return await super.Get(calls[5].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  Apagar(value: Centro) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .delete(calls[3].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async ListarAtivos(): Promise<Centro[]> {
    return await super
      .Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async getCentroById(id: number): Promise<Centro> {
    let ok: boolean = false;
    let error: any = undefined;
    let centro: Centro;
    await super
      .Get(calls[0].rota)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        centro = response.data.map((item: Centro) => (item.id = id))[0];
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<Centro>((resolve) => {
      resolve(centro);
    });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  hasCache(): boolean {
    const centrosCache: string = String(localStorage.getItem(cacheKey));
    if (centrosCache && centrosCache !== "null") {
      return true;
    }

    return false;
  }

  ListarFromCache(): Centro[] {
    let result: Centro[] = JSON.parse(String(localStorage.getItem(cacheKey)));
    return result;
  }

  AdicionarListaAoCache(value: Centro[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: Centro) {
    localStorage.setItem(cacheKeySelC, JSON.stringify(value));
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
export default CentroDataset;
